module.exports = __webpack_public_path__ + "static/media/iat.e56f9a1b.jpeg";